import React, {useContext, useEffect} from 'react';

import {useFloatingMenuItem} from '@pb/kit-component-floating';
import {ListBoxItem} from '@pb/kit-component-listbox';

import {AutosuggestContext} from './autosuggest.context';

import type {ListBoxItemProps} from '@pb/kit-component-listbox';


export interface AutosuggestItemProps extends ListBoxItemProps {
    /**
     * The value of the item. It will be passed to the `onItemSelect` callback of the Autosuggest component.
     */
    value: unknown,
}

/**
 * The `AutosuggestItem` component is a single item in the Autosuggest list.
 * Use with `Autosuggest` component or `useAutosuggest` hook.
 */
export function AutosuggestItem({value, ...props}: AutosuggestItemProps) {
    const {onItemSelect, itemsValuesOrder, onMountItem, onUnmountItem} = useContext(AutosuggestContext);
    const {
        index,
        ref,
    } = useFloatingMenuItem();

    useEffect(() => {
        if (itemsValuesOrder.current) {
            itemsValuesOrder.current[index] = value;
        }
    }, [index, itemsValuesOrder, value]);

    useEffect(() => {
        onMountItem();

        return () => {
            onUnmountItem();
        };
    }, [onUnmountItem, onMountItem]);

    return (
        <ListBoxItem
            ref={ref}
            {...{
                ...props,
                onClick: e => {
                    onItemSelect(value, 'MOUSE_DOWN', e.nativeEvent);
                    props.onClick?.(e);
                },
            }}
        />
    );
}
